import { Component, OnInit, WritableSignal, signal, effect, computed } from '@angular/core';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {StandardDropdown} from '../../../../../../shared/models/components/dropdowns/standardDropdown.models';
import { DividerModule } from 'primeng/divider';
import { DatePickerModule } from 'primeng/datepicker';
import { TextareaModule } from 'primeng/textarea';
import { RadioButtonModule  } from 'primeng/radiobutton';
import { FeedbackService } from '../../../../../../shared/services/componentsServices/feedback.service';
import { givenFeedbackModel, givenFeedbackField, runsDataByUserRequest, currentFeedbackModel } from '../../../../../../shared/models/serviceModels/request/feedbackReq.model';
import { feedbackFormsData, feedbackDataSetValues, prediction} from '../../../../../../shared/models/serviceModels/response/feedbackRes.model';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { PredictionSelectorComponent, RunData } from '../shared/prediction-selector/prediction-selector.component';
import { BaseFeedbackFormComponent } from '../shared/base-feedback-form.component';

@Component({
    selector: 'app-market-events-form',
    standalone: true,
    imports: [SelectModule,
        FormsModule,
        CommonModule,
        FontAwesomeModule,
        DividerModule,
        DatePickerModule,
        TextareaModule,
        RadioButtonModule,
        PredictionSelectorComponent],
    templateUrl: './market-events-form.component.html',
    styleUrl: './market-events-form.component.scss'
})
export class MarketEventsFormComponent extends BaseFeedbackFormComponent implements OnInit {
  

  protected givenFeedbackResponse: currentFeedbackModel = { feedbackFields: [], userId: "", userRoleId: 1, feedbackDate: new Date(), feedbackTypeId: 1};
   
  override predictionDropdown:  WritableSignal<StandardDropdown[]>  = signal([]);
  freeText: string = '';
  isPredictionLoading = false;
  selectedPrediction: StandardDropdown= {description: "", value: ""};
  predictionDetails: WritableSignal<StandardDropdown[]> = signal([]);

  predictionsByRunId: WritableSignal<prediction[]> = signal([]);
  override runsData: WritableSignal<RunData[]> = signal([]);
  
  faSpinner: IconDefinition = faSpinner;

  isFieldDisabled = computed(() => {
    return this.feedbackService.getFieldsStatus();
  })

  


  ngOnInit(): void {
    
    const singleData = this.feedbackService.getFormData()();

    this.feedbackFormData.set(singleData ? singleData : null);

    this.setDropdownsValues();
    
    this.setDefaultValues();

  }

  setDropdownsValues(){

    // this.setDefaultScenariosListByUser();
    this.setRunsListByUser();
  }

  
  setDefaultValues() {
   
    const defaultFeedbackData = this.feedbackService.getFeedbackBeforeSubmit();
    this.givenFeedbackResponse = defaultFeedbackData? defaultFeedbackData : this.givenFeedbackResponse;
    
    let formData= this.feedbackFormData();
    this.givenFeedbackResponse.predictionSourceTypeId = formData?.predictionSourceType?.feedbackFieldValues?.find(type => type.field?.toLowerCase().trim() === "prediction".toLowerCase())?.id ;
  }

  


  onPredictionSelectionChange(event: any) {

    let formData= this.feedbackFormData();

    this.givenFeedbackResponse = {
      ...this.givenFeedbackResponse,
      predictionSourceTypeId:
      formData?.predictionSourceType?.feedbackFieldValues?.find(
          item => item.field && item.field.toLowerCase().trim() === "prediction"
      )?.id,
      // predictionSourceTypeId: formData?.predictionSourceType?.feedbackFieldValues?.find(type => type.field?.toLowerCase() === "prediction".toLowerCase())?.id,
      predictionRunId: event.value.value,
      predictionRunDate: new Date(event.value.description)
    };

    this.feedbackService.setFeedbackValues(this.givenFeedbackResponse!);

    this.getPredictionData();
    
  }

  // Handler for the new prediction-selector component
  override onRunSelected(runData: RunData) {
    super.onRunSelected(runData);
  }  

  mapGetPredictionsByRunIdRequest(): runsDataByUserRequest{
    let request:runsDataByUserRequest = {
      runIds: this.givenFeedbackResponse.relatedRunIds?.map(id => id.toString())
    };

    return request;
  }

  
  getPredictionData(){
    this.isPredictionLoading = true;
    let request:runsDataByUserRequest= this.mapGetPredictionsByRunIdRequest();

    this.feedbackService.getPredictionsByUser(request).subscribe({
      next: (response) => {
        this.isPredictionLoading = false;
        if(response.errorMsg || !response.predictions || response.predictions.length === 0) return;   
        
        this.predictionsByRunId.set(response.predictions || []);
        this.mapPredictionDataToFeedbackResponse(response.predictions);
        this.checkIfAllMandatoryFieldsAreFilled();
      },
      error: (error) => {
        this.isPredictionLoading = false;
        console.error('Error fetching predictions by user:', error);
      }
    });
   
  }

  mapPredictionDataToFeedbackResponse(predictions: prediction[]) {

    if (predictions.length === 0) {
      return;
    }

    const formData = this.feedbackFormData();
    const manualSourceTypeId = formData?.predictionSourceType?.feedbackFieldValues?.find(
      type => type.field?.toLowerCase().trim() === "manual"
    )?.id;

    let predictionDetailsList: StandardDropdown[] = predictions.map(prediction => {
      let caseName = prediction.case_name || 'N/A';
      
      if (manualSourceTypeId && prediction.source_type_id === manualSourceTypeId) {
        caseName = `${caseName} - Manual`;
      }

      let formattedValue = 'N/A';
      if (prediction.value !== null && prediction.value !== undefined) {
        const value = prediction.value;
        formattedValue = Number.isInteger(value) ? value.toString() : value.toFixed(3);
      }

      return {
      description: `${caseName}: $ ${formattedValue}`,
      value: prediction.id?.toString() || ''
      };
    });

    this.predictionDetails.set(predictionDetailsList);

  }

  validateFreeText(event: any) {
    let freeText = this.freeText;

    const sanitizedText = freeText.replace(/[^a-zA-Z0-9 .,!?'"()\-$\/#@%]/g, '');

    // Check if the sanitized text has at least 3 words
    const wordCount = sanitizedText.trim().split(/\s+/).length;
    this.checkIfAllMandatoryFieldsAreFilled();

    if (wordCount >= 2) {
      this.storeInputsValuesIntoFeedbackResponse(sanitizedText, 'free_text');
      
    }
  }

  checkIfAllMandatoryFieldsAreFilled(){
    let areMandatoryFieldsFilled = false;
    let runDate = this.givenFeedbackResponse.predictionRunDate;
    
    if (
      this.selectedPrediction &&
      this.predictionDetails().length>0 &&
      this.freeText.trim().split(/\s+/).length >=2
    ) {
      areMandatoryFieldsFilled = true;
    }
    
    this.feedbackService.setAreMandatoryFieldsLoaded(areMandatoryFieldsFilled);
  }

  storeInputsValuesIntoFeedbackResponse(value:number | string, type: string){

    const formFieldsData = this.feedbackFormData();


    switch(type){

      case 'free_text':
        {
         
          let formFeedbackField = formFieldsData?.feedbackFields?.feedbackFieldValues?.find(item => item.field?.toLowerCase() === "free_text".toLowerCase());
         
          let feedbackField: givenFeedbackField = {
            dataTypeId: formFeedbackField?.dataTypeId || 0,
            fieldId: formFeedbackField?.id,
            fieldName: formFeedbackField?.field || "",
            fieldDescription: formFeedbackField?.description || "",
            value: value.toString()
          };

          this.storeFeedbackField(feedbackField);

          break; 
        }
        
        
      default:
        break;
      
      }
  
  }

  storeFeedbackField(givenFeedbackField:givenFeedbackField){

    
    let existingFieldIndex = this.givenFeedbackResponse.feedbackFields.findIndex(field => field.fieldName === givenFeedbackField.fieldName);

    if (existingFieldIndex !== -1) {
      this.givenFeedbackResponse.feedbackFields[existingFieldIndex] = givenFeedbackField;
    } else {
      this.givenFeedbackResponse.feedbackFields.push(givenFeedbackField);
    }

    this.feedbackService.setFeedbackValues(this.givenFeedbackResponse!);

  }


}
